<template>
  <div class="main">
    <div class="bar">
      <div style="width: 100%;">
        <van-swipe :autoplay="3000" style="height: 200px; box-shadow: 0 0 2rem #f5f5f5;">
          <van-swipe-item v-for="(image, index) in images" :key="index">
            <img :src="image" style="width: 100%;height: 200px;"/>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="info" style="font-size: 2.3rem;align-items: flex-start;">
      <span style="margin-left: 5rem;margin-right: 5rem;display: flex">
        <span style="flex: 1;overflow: scroll;">地址：{{address }}</span>
      </span>
      <span style="margin-left: 5rem;margin-top: 1.5rem;margin-bottom: 1rem;display: flex;justify-content: space-between;">电话：
        <a style="color: #409EFF;" :href="'tel:' + phone " rel="external nofollow">{{ phone }}</a>
        <a style="color: #409EFF;margin-left: 1em;width: 6em;display: flex;align-items: center;"
           :href="mapurl"
           rel="external nofollow">一键导航 <van-icon
            name="share"/></a>
      </span>
    </div>
    <van-swipe
        :loop="false"
        class="back-swipe"
        style="background-color: #ffffff"
    >
      <van-swipe-item v-for="(item,index) in menuListPage" :key="index">
        <van-sticky>
          <van-grid :column-num="4" :border="false">
            <van-grid-item :url="jtem.url" v-show="jtem.status  && jtem.url!==''" @click="toMenuSkip(jtem)"
                           v-for="(jtem,index) in item.item" :key="index+99">
              <van-image :src='jtem.src'/>
              <span class="van-text">{{ jtem.name }}</span>
            </van-grid-item>
            <van-grid-item :to="jtem.to" v-show="jtem.status && jtem.url===''" @click="toMenuSkip(jtem)"
                           v-for="(jtem,index) in item.item" :key="index">
              <van-image :src='jtem.src'/>
              <span class="van-text">{{ jtem.name }}</span>
            </van-grid-item>

          </van-grid>
        </van-sticky>
      </van-swipe-item>
    </van-swipe>
    <div v-if="hotPackages" style="width: 100%;">
      <van-divider>热门套餐</van-divider>
    </div>
    <div class="package" v-if="hotPackages">
      <div class="package-item" v-for="item in packages" v-bind:key="item.packageId"
           @click="toDetail(item.packageId,item.checkTotal)">
        <div style="width: 20%;height: 100%;padding: 10px;">
          <img :src='item | picFilter' style="width: 70px;height: 70px;border-radius: 1rem;">
        </div>
        <div
            style="width: 80%;height: 100%;display: flex;flex-flow: column;justify-content: space-around;padding-right: 10px">
          <span style="font-weight: 700;font-size: 2.5rem;color:#171A32;margin-top: 8px;margin-bottom: 10px">
            {{ item.packageName }}
          </span>
          <span style="font-size: 2.2rem;color: #898989;">
            <span v-if="hospitalnameShow" style="padding-right: 1em;">{{ hospitalname }}</span>
            性别：
            <span style="margin-right: 2.2rem;" v-if="item.sexId == '1'">男性</span>
            <span style="margin-right: 2.2rem;" v-if="item.sexId == '2'">女性</span>
            <span style="margin-right: 2.2rem;" v-if="item.sexId == '0'">不限</span>
            婚姻：

            <span style="margin-right: 2.2rem;" v-if="item.marriage == '1'">已婚</span>
            <span style="margin-right: 2.2rem;" v-if="item.marriage == '2'">未婚</span>
            <span style="margin-right: 2.2rem;" v-if="item.marriage == '0'">不限</span>
          </span>
          <div style="width: 100%;display: flex;justify-content: flex-end;align-items: center;">
            <span v-if="showMoney && showOriginalMoney" style="font-size:2.2rem;color: #F56C6C;margin-right: 1em;">优惠价<em
                style="font-size: 1.8rem">￥</em>{{ item.actualPrice }}</span>
            <span v-if="showMoney && !showOriginalMoney" style="font-size:2.2rem;color: #F56C6C;margin-right: 1em;"><em
                style="font-size: 1.8rem">￥</em>{{ item.actualPrice }}</span>
            <span v-if="showMoney && showOriginalMoney" style="font-size: 2.2rem;color: #898989;margin-right: 1em;">原价<em
                style="font-size: 1.8rem">￥</em>{{ item.price }}</span>
            <!--            <span style="font-size: 2.3rem;color: #898989;margin-right: 2rem;">{{ item.checkTotal }} 人已选</span>-->
            <!--            <span style="font-size: 2rem;color: #c8c9cc;margin-right: 2rem;" @click.stop="showDetail(item.packageId)">查看项目<van-icon name="arrow" /></span>-->
            <van-button round hairline size="mini" type="info" style="font-size: 2rem;padding-left: 1.5rem"
                        @click.stop="showDetail(item.packageId)">查看项目
              <van-icon name="arrow"/>
            </van-button>
          </div>
        </div>
        <div>
        </div>
      </div>
      <div style="width: 100%;">
        <van-divider>没有更多了</van-divider>
      </div>
      <div class="copyright" v-if="copyrightShow">
        <a href="https://beian.miit.gov.cn" class="link">{{ copyrightText }}</a>
      </div>
    </div>
    <div class="footer">
      <van-tabbar v-model="active" active-color="#409EFF" inactive-color="#000">
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <!-- 2025-02-26 ZLS 新增模块跳转       -->
        <van-tabbar-item icon="comment-o" :badge="messageCount" @click="toMessage" v-if="messageShow">健康科普
        </van-tabbar-item>
        <!-- 2024-08-19 ZLS 新增模块跳转       -->
        <van-tabbar-item icon="todo-list-o" :badge="task" @click="toTask">待办任务</van-tabbar-item>
        <van-tabbar-item icon="shopping-cart-o" @click="toOrders">我的订单</van-tabbar-item>
        <!--        <van-tabbar-item icon="todo-list-o" badge="5" @click="toTask">待办任务</van-tabbar-item>-->
        <van-tabbar-item icon="user-o" @click="toUserinfo">个人中心</van-tabbar-item>
      </van-tabbar>
    </div>

    <van-popup close-icon="close" closeable v-model="showPackageDetail"
               round position="bottom" :style="{ height: '90%' }">
      <div style="width: 100%;height: 7%"></div>
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <span style="font-size: 3rem;margin-left: 2rem;">{{ packageDetail.packageName }}</span>
        <span style="font-size: 2.3rem;color: #898989;padding: 1em;color: #576b95;">{{
            packageDetail.description
          }}</span>
      </div>
      <div style="width: 100%;height: 85%;display: flex;justify-content: center;">
        <div style="width: 96%;height: 100%;overflow-y: scroll;">
          <div v-for="(item,index) in packageDetail.basicGroupInfos" v-bind:key="item.groupId">
            <van-cell center style="border-bottom: 1px solid #f5f0f0;"
                      :title-class="item.isDelete == '2'?'text-decoration':''"
                      :title=" (index + 1) + '、' + item.groupName"
                      :label="item.clinicalSignIficance | valueFilter"/>
          </div>
          <van-empty v-if="packageDetail.basicGroupInfos == null || packageDetail.basicGroupInfos.length <= 0"
                     description="未设置项目"/>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import 'vant/lib/index.css'
import {
  getQuestionnaireTypeID,
  getTopPackageList,
  getConsentFormCount,
  getPackageDetialByPackageId, getWeChatMessageCount, updatePatientId
} from '@/api/module/index'
import {getUserInfoByPhone, loginByOpenid} from '@/api/module/user'
import {Dialog, Toast} from "vant";
import {decrypt, encrypt} from "../../assets/utils/cryptoUtil";
import {loginByCode} from "@/api/module/auth";

export default {
  name: "index",
  data() {
    return {
      copyrightShow: window.g.VUE_APP_COPYRIGHT_ISSHOW,
      copyrightText: window.g.VUE_APP_COPYRIGHT_TEXT,
      mapurl: window.g.VUE_APP_MAP_URL,
      homeRedirect: window.g.VUE_APP_HOME_REDIRECT,
      hotPackages: window.g.VUE_APP_HOT_PACKAGES,
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      showOriginalMoney: window.g.VUE_APP_SHOW_ORIGINAL_MONEY,//是否显示原价
      hospitalname: window.g.VUE_APP_HOSPITALNAME,
      hospitalnameShow: window.g.VUE_APP_HOSPITALNAME_SHOW,//套餐列表是都显示医院名称
      VUE_APP_GET_OPENID_TYPE: window.g.VUE_APP_GET_OPENID_TYPE,
      VUE_APP_GET_OPENID_PARAM_NAME: window.g.VUE_APP_GET_OPENID_PARAM_NAME,
      VUE_APP_GET_OPENID_URL: window.g.VUE_APP_GET_OPENID_URL,
      student: '',//是否开启学生体检
      show: false,
      active: 0,
      images: [window.g.VUE_APP_SUB_DIR + "/hospital/1.jpg",
        window.g.VUE_APP_SUB_DIR + "/hospital/2.jpg",
        window.g.VUE_APP_SUB_DIR + "/hospital/3.jpg",
        window.g.VUE_APP_SUB_DIR + "/hospital/4.jpg",
        window.g.VUE_APP_SUB_DIR + "/hospital/5.jpg",
      ],
      code: '',
      token: '',
      phone: '',//医院电话
      address: '',//医院联系地址
      name: '',
      introduction: '',
      packages: [],
      task: 0, // 待办任务数量
      showPackageDetail: false,
      packageDetail: {},
      // 模块是否隐藏
      vajrayanaSize: 4,
      menuList: [{
        name: '单位预约',
        src: require("@/assets/images/company.svg"),
        to: '/companyOrders',
        url: '',
        status: true,
        acronym: 'dwyy',
        sort: 1
      }
        , {
          name: '个人预约',
          src: require("@/assets/images/package.svg"),
          to: '/package',
          url: '',
          status: true,
          acronym: 'gryy',
          sort: 2
        }, {
          name: '检前问卷',
          src: require("@/assets/images/question.svg"),
          to: '/preconsultation',
          url: '',
          status: true,
          acronym: 'jqwj',
          sort: 3
        }, {
          name: '体检报告',
          src: require("@/assets/images/report.svg"),
          to: '/report',
          url: '',
          status: true,
          acronym: 'tjbg',
          sort: 4
        }, {
          name: '学生体检',
          src: require("@/assets/images/student.svg"),
          to: '/student',
          url: '',
          status: false,
          acronym: 'xstj',
          sort: 5
        }, {
          name: '我的订单',
          src: require("@/assets/images/orders.svg"),
          to: '/student',
          url: '',
          status: false,
          acronym: 'wddd',
          sort: 6
        }, {
          name: '体检须知',
          src: require("@/assets/images/notice.svg"),
          to: '/notice',
          url: '',
          status: true,
          acronym: 'tjxz',
          sort: 7
        }, {
          name: '体检排队',
          src: require("@/assets/images/queuing.svg"),
          to: '/queuing',
          url: '',
          status: true,
          acronym: 'tjpd',
          sort: 8
        }, {
          name: '满意度评价',
          src: require("@/assets/images/survey.svg"),
          to: '',
          url: '',
          status: true,
          acronym: 'mydpj',
          sort: 9
        }, {
          name: '心理问卷',
          src: require("@/assets/images/xlwj.svg"),
          to: '/psychologicalQuestionnaire',
          url: '',
          status: true,
          acronym: 'xlwj',
          sort: 10
        }, {
          name: '交通指引',
          src: require("@/assets/images/map_1.svg"),
          to: '',
          url: '',
          status: true,
          acronym: 'jtzy',
          sort: 11
        },
        {
          name: '健康证',
          src: require("@/assets/images/jkz.svg"),
          to: 'healthCertificateList',
          url: '',
          status: true,
          acronym: 'jkz',
          sort: 12
        }
      ],
      // 分页后的菜单页
      menuListPage: [],
      messageCount: 0, // 消息数量
      messageShow: window.g.VUE_APP_MESSAGE_NOTIFICATION, // 消息是否显示
      messageInterval: null,// 定时器引用
    };
  },
  created() {
    let b = false;
    //20240912 ZLS  获取本地会话缓存，判断是否开启推送通知跳转导检页面
    let isPush = localStorage.getItem("isPushWeChat")
    if (isPush == 'true') {
      localStorage.removeItem("isPushWeChat")
      this.$router.push({name: 'queuing'})
    }

    if (localStorage.getItem("topath") != null && localStorage.getItem("topath") == '/companyOrders') {
      this.$router.push({name: localStorage.getItem("topath").replace('/', '')})
    }
    //是否开启微信登录
    if (window.g.VUE_APP_ISWECHAT == '1') {
      if ("home_url_param_openId" == this.VUE_APP_GET_OPENID_TYPE) {
        var openId = "";
        if (sessionStorage.getItem("userinfo") != undefined) {
          let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
          openId = userinfo.openid
        } else {
          openId = this.getUrlParam(this.VUE_APP_GET_OPENID_PARAM_NAME)
        }
        if (openId != null && openId != '') {
          var data = {
            wechatid: openId
          }
          sessionStorage.setItem("userinfo", JSON.stringify({
            openid: openId,
            nickname: ''
          }));
          if (localStorage.getItem("token") == undefined) {
            this.loginByOpenid(data)
          }
        } else {
          window.location.href = this.VUE_APP_GET_OPENID_URL
        }
      } else {
        var code = this.getUrlParam('code')
        var local = window.location.href
        if (code == null || code == '') {
          window.location.href =
              'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
              window.g.VUE_APP_WECHAT_APPID + '&redirect_uri=' +
              encodeURIComponent(local) +
              '&response_type=code&scope=' + process.env.VUE_APP_WECHAT_TYPE
              + '&state=state#wechat_redirect'
        } else {
          if (sessionStorage.getItem("userinfo") == null) {
            this.code = code
            var data = {
              code: code
            }
            this.getopenid_data(data)
          }
        }
      }
    }
    this.replaceMenu()
    this.student = window.g.VUE_APP_STUDENT
    this.phone = window.g.VUE_APP_PHONE
    this.address = window.g.VUE_APP_ADDRESS
    this.name = window.g.VUE_APP_HOSPITALNAME
    this.introduction = process.env.VUE_APP_INTRODUCTION
    //1、查询推荐套餐
    this.getTop()
    // 查询待办任务
    this.getConsentFormCount()
    // 查询消息数量
    this.getWeChatMessageCount()
  },
  filters: {
    valueFilter: function (value) {
      if (value == null || value == '') {
        return ''
      } else {
        return value
      }
    },
    filterMoney(value, showMoney) {
      if (showMoney) {
        return '（￥' + value + '）'
      } else {
        return ""
      }
    },
  },
  methods: {
    toSurvey() {
      let params = {
        typename: "满意度调查问卷"
      }
      getQuestionnaireTypeID(params).then(res => {
        if (res.code == 200) {
          this.typeid = res.data
          if (this.typeid != null) {
            this.$router.push({name: 'survey'})
          } else {
            Toast.fail("【满意度调查问卷】种类未设置")
          }
        }
      })
    },
    getInfoByPhone() {
      if (localStorage.getItem("loginuser") == null) {
        this.$router.push({name: 'login'})
        return
      }
      let param = {
        phone: encrypt(JSON.parse(localStorage.getItem("loginuser")).phone)
      }
      getUserInfoByPhone(param).then(res => {
        // console.log(res)
      })
    },
    getTop() {
      getTopPackageList({}).then(res => {
        if (res.code == 200) {
          this.packages = res.data
        }
      })
    },
    //2024-03-12 ZLS  新增获取待办任务的数量
    getConsentFormCount() {
      let loginuser = JSON.parse(localStorage.getItem("loginuser"));
      if (loginuser == null) {
        return
      }
      let param = {
        patientid: loginuser.patientid
      }

      // 判断patientId是否为空，如果为空则调用更改patientId接口
      if (loginuser.patientid == '' || loginuser.patientid == null) {
        console.log('patientId为空', loginuser.physicalno)
        updatePatientId({'physicalno': loginuser.physicalno}).then(res => {
          if (res.data) {
            loginuser.patientid = res.data
            localStorage.setItem("loginuser", JSON.stringify(loginuser))
          }
        })
      }
      getConsentFormCount(param).then(res => {
        if (res.code == 200 && res.data > 0) {
          this.task = res.data;
        }
      })
    },
    toPackage() {
      if (this.radio == undefined) {
        Toast.fail('请选择体检人');
      } else {
        this.$router.push({name: 'package'})
      }
    },
    toDetail(packageId, checkTotal) {
      this.$router.push({name: 'packageDetail', query: {packageId: packageId, checkTotal: checkTotal}})
    },
    toOrders() {
      this.$router.push({name: 'orders'})
    },
    toTask() {
      this.$router.push({name: 'letterConsent'})
    },
    toMessage() {
      this.$router.push({name: 'message'})
    },
    toReport() {
      this.$router.push({name: 'report'})
    },
    toUserinfo() {
      this.$router.push({name: 'userinfo'})
    },
    tonavigation() {
      if (window.g.VUE_APP_NAVIGATION == 1) {
        this.$router.push({name: 'navigation'})
      } else {
        Toast.fail('抱歉，该功能未启用！');
      }
    },
    //查看套餐明细项目
    showDetail(packageId) {
      this.showPackageDetail = true
      getPackageDetialByPackageId({packageId: packageId}).then(res => {
        if (res.code == 200) {
          this.packageDetail = res.data
        } else {
          Toast.fail('服务器出错！');
        }
      })
    },
    // 菜单自动分页
    menuAutoPage() {
      // 过滤掉被屏蔽的模块和被关掉的
      var menuList = this.menuList.filter((item) => item.status)
      // 根据菜单长度自动分页
      let page = Math.ceil(menuList.length / 8)
      var menuListPage = []
      for (let i = 0; i < page; i++) {
        var item = []
        for (let j = menuList.length - 1; j >= 0; j--) {
          if (i * 8 <= j && j < (i + 1) * 8) {
            item.push(menuList[j])
          }
        }
        item = item.sort((a, b) => a.sort - b.sort);

        menuListPage.push({num: i, item: item})
      }
      this.menuListPage = menuListPage
    },
    // 替换自定义菜单配置
    replaceMenu() {
      var vajrayana = window.g.VUE_APP_VAJRAYANA_MODULE_HIDE
      if (vajrayana == null) {
        this.menuList = this.menuList.sort((a, b) => a.sort - b.sort);
        this.menuAutoPage()
        return
      }
      for (let i = this.menuList.length - 1; i >= 0; i--) {
        vajrayana.forEach(item => {
          if (item.acronym == this.menuList[i].acronym) {
            if (!item.status && item.status != null) {
              this.menuList[i].status = item.status
            }
            if (item.name) {
              this.menuList[i].name = item.name
            }
            if (item.src) {
              this.menuList[i].src = item.src
            }
            if (item.to) {
              this.menuList[i].to = item.to
            }
            if (item.url) {
              this.menuList[i].url = item.url
            }
            if (item.sort) {
              this.menuList[i].sort = item.sort
            }
          }
        })
      }
      this.menuList = this.menuList.sort((a, b) => a.sort - b.sort);
      this.menuAutoPage()
    },
    // 按缩写跳转对应方法路径
    toMenuSkip(item) {
      if (item.acronym == 'mydpj') {
        this.toSurvey()
      }
      if (item.acronym == 'jtzy') {
        this.tonavigation()
      }
    },
    loginByOpenid(openid) {
      let params = {
        wechatid: openid
      }
      loginByOpenid(params).then(res => {
        let _this = this;
        if (res.data != null) {
          let loginuser = JSON.parse(JSON.stringify(res.data))
          localStorage.setItem("loginuser", JSON.stringify(loginuser))
          localStorage.setItem("token", loginuser.token)
          if (this.$route.params.pathName) {
            this.$router.push({name: this.$route.params.pathName})
          } else {
            this.$router.push({name: 'home'})
          }
        } else {
          let url = window.location.href.split('#')[0]
          let search = url.split('?')[0]
          //当前微信未绑定，返回登录页面重新登录进行绑定
          Dialog.confirm({
            message: '当前微信未绑定，返回登录页面重新登录进行绑定',
          }).then(() => {
            console.log(search + '#/login')
            window.location.href = search + '#/login'
            return
          }).catch(() => {
            Dialog.close()
            console.log(search + '#/login')
            window.location.href = search + '#/login'
          });
          setTimeout(function () {
            Dialog.close()
            window.location.href = search + '#/login'
          }, 6000)
        }
      })
    },
    getopenid_data(data) {
      loginByCode(data).then(res => {
        sessionStorage.setItem("userinfo", JSON.stringify(res.data));
      })
    },
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
    getWeChatMessageCount: function () {
      if (!this.messageShow) {
        return;
      }
      let loginuser = JSON.parse(localStorage.getItem("loginuser"));

      if (!this.messageInterval) {
        getWeChatMessageCount({patientID: loginuser.patientid}).then(res => {
          const messageCount = localStorage.getItem("messageCount");
          this.messageCount = res.data - messageCount
        })
      }
    }
  },
  beforeDestroy() { // 或者使用 unmounted
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  },
}
</script>

<style scoped>

.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F8F7FC;
}

.bar {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.info {
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.item span {
  font-size: 3rem;
  font-weight: 600;
}

.package {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-bottom: 14rem;
}

.package-item {
  width: 96%;
  min-height: 13rem;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  display: flex;
  flex-flow: row;
  justify-content: center;
  box-shadow: 0 0 1.5rem #f5f5f5;
}

.van-image {
  width: 40%;
}

.van-text {
  font-size: 2.3rem;
  margin-top: 1rem;
  color: #474646;
}

.copyright {
  text-align: center;
  font-size: 2em;
  color: #999;
  padding: 2em;
}

.copyright .link {
  text-decoration: underline;
  color: #999;
}
</style>
